import { ProgressBar } from 'baseui/progress-bar'
import type { ProgressBarOverrides } from 'baseui/progress-bar'
import { StyledPceSearchBlockMessage } from '../styled-components'

export interface PceSearchBlockMessageProps {
  message: string | null
  countdown: { value: number; maxValue: number } | null
  countdownOverrides: ProgressBarOverrides
  isPulse: boolean
}

const PceSearchBlockMessage = ({ message, countdown, countdownOverrides, isPulse }: PceSearchBlockMessageProps) => {
  if (message === null) {
    return null
  }

  return (
    <StyledPceSearchBlockMessage $pulse={isPulse} role='status'>
      <span>{message}</span>
      {countdown !== null && (
        <ProgressBar value={countdown.value} maxValue={countdown.maxValue} overrides={countdownOverrides} />
      )}
    </StyledPceSearchBlockMessage>
  )
}

export default PceSearchBlockMessage
